/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SelectPreQualificationFormTemplateQueryVariables = {};
export type SelectPreQualificationFormTemplateQueryResponse = {
    readonly patientFormTemplateMany: ReadonlyArray<{
        readonly _id: string;
        readonly title: string | null;
    } | null> | null;
};
export type SelectPreQualificationFormTemplateQuery = {
    readonly response: SelectPreQualificationFormTemplateQueryResponse;
    readonly variables: SelectPreQualificationFormTemplateQueryVariables;
};



/*
query SelectPreQualificationFormTemplateQuery {
  patientFormTemplateMany(filter: {type: preQualification}) {
    _id
    title
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "preQualification"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectPreQualificationFormTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "PatientFormTemplate",
        "kind": "LinkedField",
        "name": "patientFormTemplateMany",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": "patientFormTemplateMany(filter:{\"type\":\"preQualification\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectPreQualificationFormTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "PatientFormTemplate",
        "kind": "LinkedField",
        "name": "patientFormTemplateMany",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "patientFormTemplateMany(filter:{\"type\":\"preQualification\"})"
      }
    ]
  },
  "params": {
    "cacheID": "02dd23d2eb2dc9653309d90c347dc832",
    "id": null,
    "metadata": {},
    "name": "SelectPreQualificationFormTemplateQuery",
    "operationKind": "query",
    "text": "query SelectPreQualificationFormTemplateQuery {\n  patientFormTemplateMany(filter: {type: preQualification}) {\n    _id\n    title\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '057e2d88a8af5687064fce07357bb757';
export default node;
